function initAnimatedDot() {
  const items = document.querySelectorAll(".mb-menu > li");
  const dot = document.getElementById("mb-animated-dot");
  const menu = document.querySelector(".mb-menu");

  if (!dot || !menu || !items.length) return;

  const moveDotToItem = (item, show = true) => {
    if (!item || item.classList.contains("mb-button-menuentry")) return;

    const rect = item.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();

    dot.style.left = rect.left - menuRect.left + "px";
    dot.style.top =
      rect.top - menuRect.top + rect.height / 2 - dot.offsetHeight / 2 + "px";
    dot.style.opacity = show ? "1" : "0";
  };

  const currentItem = menu.querySelector(
    ":scope > li.current-menu-item:not(.mb-button-menuentry), :scope > li.current-menu-parent:not(.mb-button-menuentry), :scope > li.current-menu-ancestor:not(.mb-button-menuentry), :scope > li.current_page_item:not(.mb-button-menuentry), :scope > li.current_page_parent:not(.mb-button-menuentry), :scope > li.current_page_ancestor:not(.mb-button-menuentry)"
  );

  if (currentItem) {
    moveDotToItem(currentItem, true);
  } else {
    dot.style.opacity = "0";
  }

  const moveToCurrentItem = () => {
    if (currentItem) {
      moveDotToItem(currentItem, true);
    }
  };

  items.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      moveDotToItem(item, true);
    });
  });

  menu.addEventListener("mouseleave", function () {
    if (currentItem) {
      moveDotToItem(currentItem, true);
      return;
    }

    dot.style.opacity = "0";
  });

  window.addEventListener("load", moveToCurrentItem);
  window.addEventListener("resize", moveToCurrentItem);
}

export function createAnimatedDotDiv() {
  // console.log('Creating animated dot div');
  const parentDiv = document.getElementById("mb-main-menu");
  if (!parentDiv) return;

  // Neues Div-Element mit Klasse erstellen
  const dotDiv = document.createElement("div");
  dotDiv.id = "mb-animated-dot";

  // Div einfügen (z.B. direkt nach der ul im wrapper)
  const ul = parentDiv.querySelector("ul");
  if (ul) {
    ul.after(dotDiv);
    // Alternativ: parentDiv.appendChild(dotDiv); // falls die Position egal ist
  }

  // console.log('Animated dot div created');
  initAnimatedDot();
}
